
import { useState } from "react";
import { useLocation } from "react-router-dom";
import { QRCodeCanvas } from 'qrcode.react';
import { getFormatFecha } from "../../helpers/dates";
import './codeqr.css'

const QrCode = () => {

    const location = useLocation();
    const [village] = useState(location.state.village)

    return (
        <div className="container-data">
            <h1>Código QR para {village.PUE_NOMBRE} el {getFormatFecha(village.PUE_FECACT)}</h1>
            <div className="codeqr">
            {(village.PUE_NOMBRE !=="Campo de las Naciones")
            ? 
                <QRCodeCanvas
                    value= {`https://poptelera.byjim.es/${village.PUE_CLAVE}`}
                    size='256'
                    level="M"
                    includeMargin='true'
                    imageSettings={{
                        src: require('../../assets/logoPoptelera.png'),
                        x: undefined,
                        y: undefined,
                        height: 100,
                        width: 100,
                        escavate: true
                    }}
                />
            :<QRCodeCanvas
                    value= {`https://poptelera.byjim.es/${village.PUE_CLAVE}`}
                    size='256'
                    level="M"
                    includeMargin='true'
                    imageSettings={{
                        src: require('../../assets/moeveQr1.png'),
                        x: undefined,
                        y: undefined,
                        height: 38,
                        width: 180,
                        escavate: true
                    }}
                />
            }
            

            </div>


                <p>{`https://poptelera.byjim.es/${village.PUE_CLAVE}`}</p>
        </div>
    )
}
export default QrCode